import { render, staticRenderFns } from "./ImageLazy.vue?vue&type=template&id=0bb31ca4&scoped=true"
import script from "./ImageLazy.vue?vue&type=script&lang=js"
export * from "./ImageLazy.vue?vue&type=script&lang=js"
import style0 from "./ImageLazy.vue?vue&type=style&index=0&id=0bb31ca4&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb31ca4",
  null
  
)

export default component.exports